import GridPartialTitle from '@components/grid-partial-title';
import Container from '@components/ui/container';
import React, { ReactElement } from 'react';
import Divider from './Divider';

// TODO types

function PartialHeader(block: any): ReactElement {
  const { title } = block;
  return (
    <>
      <Container>
        <GridPartialTitle title={title} />
      </Container>
      <Divider />
    </>
  );
}

export default PartialHeader;
